import { render, staticRenderFns } from "./BudgetLimit.vue?vue&type=template&id=2c54214a&scoped=true&"
import script from "./BudgetLimit.vue?vue&type=script&lang=js&"
export * from "./BudgetLimit.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimit.vue?vue&type=style&index=0&id=2c54214a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54214a",
  null
  
)

export default component.exports